import { render, staticRenderFns } from "./customPages.vue?vue&type=template&id=9b48aba2"
import script from "./customPages.vue?vue&type=script&lang=js"
export * from "./customPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports